import { render, staticRenderFns } from "./allocated-center-table.vue?vue&type=template&id=07b3dc47"
import script from "./allocated-center-table.vue?vue&type=script&lang=js"
export * from "./allocated-center-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports